module.exports = __webpack_public_path__ + "static/media/bottoms.1afa5979.png";